import React from 'react';
import { colours } from './FormFieldsV3InlineStyles';

const PlaceholderStyles = () => {
  return (
    <style>
      {`
        .form-field-v3-with-placeholder::placeholder {
          color: ${colours.placeholderGrey};
          font-size: 14px;
          font-weight: 400;
        }
      `}
    </style>
  );
};

export default PlaceholderStyles;
